import { ArrowBack, SearchRounded } from '@mui/icons-material';
import { Grid, IconButton, OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';
import useSettings from '../../hooks/useSettings';
import { rtGetListData } from '../../store/slices/listSlice';

export default function ChurchListScreen() {
    const [search, setSearch] = useState('');

    const { themeMode } = useSettings();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((st) => st);

    const { churches, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('churches', 'churches'));
    }, [dispatch]);

    return (
        <Screen
            loading={busy['churches']}
            title={'Churches'}
            authPass
            backAction={
                <IconButton
                    edge="start"
                    className="mr-3"
                    color={themeMode === 'light' ? 'primary' : 'inherit'}
                    sx={{ border: 'none' }}
                    aria-label="menu"
                    onClick={() => {
                        navigate(-2);
                    }}
                >
                    <ArrowBack />
                </IconButton>
            }
        >
            <Grid item xs={12}>
                <OutlinedInput
                    value={search}
                    startAdornment={<SearchRounded className="me-2" />}
                    fullWidth
                    placeholder="Type to search"
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Grid>
            {churches
                ?.filter((church) =>
                    JSON.stringify(church)
                        .toLowerCase()
                        .includes(search.toLocaleLowerCase())
                )
                ?.map(({ id, name }) => (
                    <Grid key={`${id}`} item xs={12}>
                        <CardHome
                            title={name}
                            link={`/church/${id}`}
                            state={{ id, name }}
                            full
                        />
                    </Grid>
                ))}
        </Screen>
    );
}
